import React, {useEffect, useState} from "react";
import {useRpcSender} from "../../../../util/RpcSender";
import {com} from "../../../../provider_api";
import {useProviderProfile} from "../../../../ProviderProfileProvider";
import {TabbedPageHeader} from "../../../../components/TabbedPageHeader";
import {RpcState} from "../../../../util/RpcState";
import GetStripeUrlResponse = com.onkensu.platform.billing.GetStripeUrlResponse;
import {ActionButton} from "../../../../util/UI/ActionButton";
import {useGetStripeUrlLink} from "../../../../util/RpcHooks/GetStripeUrlLink";
import {useStripeMembershipStatusRpc} from "../../../../util/RpcHooks/GetStripeAccountStatus";
import {LoadingDots} from "../../../../util/UI/LoadingDots";

/**
 * I think there are three important states here.
 *
 * - Stripe account has not been created.
 * - Stripe account setup has not been finished.
 * - Stripe account is ready.
 * -
 * @constructor
 */
export const Billing = () => {

  // Gets the very latest from stripe.
  const getStripeAccountStatus = useStripeMembershipStatusRpc();

  const getStripeUrlRpc = useGetStripeUrlLink();

  const {business, setBusiness} = useProviderProfile();

  const createAccount = () => {
    getStripeUrlRpc.send('create_stripe_account');
  }

  const redirectToStripeOnboarding = () => {
    getStripeUrlRpc.send('get_stripe_onboarding_link');
  }

  const redirectToStripeDashboard = () => {
    getStripeUrlRpc.send('get_stripe_dashboard_link');
  }

  /**
   * Calls the stripe API via the server to see if there are any changes to the connected
   * account status that we don't have in our datastore yet. This is very important immediately
   * after returning from stripe onboarding, to ensure the changes they just made get picked
   * up, especially if the webhook is delayed.
   */
  useEffect(() => {
    getStripeAccountStatus.send();
  }, []);

  const getContent = () => {

    if (getStripeAccountStatus.rpcState.state == 'pending') {
      return <div>Loading<LoadingDots/></div>
    }

    if (getStripeAccountStatus.rpcState.state == 'error') {
      return <div className={'ErrorText'}>Error loading your account status. Please try again later</div>
    }

    if (!business?.stripeAccountId) {
      return <>
        <p>
          Secure your payments with ease. Connect your bank account through our trusted partner, <b>Stripe</b>, to start
          receiving payments from clients—it’s safe, fast, and seamless.
        </p>
        <ActionButton onClick={createAccount} rpcState={getStripeUrlRpc.rpcState}>Create your Stripe
          account</ActionButton>
      </>
    }

    if (!business.connectedAccountStatus?.accountIsReady) {
      return <>
        <p>Your billing account setup is incomplete. Please continue onboarding in Stripe.</p>
        <ActionButton onClick={redirectToStripeOnboarding} rpcState={getStripeUrlRpc.rpcState}>Continue Stripe
          onboarding</ActionButton>
      </>
    }

    return <>
      <p>Your billing account is ready to accept payments.</p>
      <ActionButton onClick={redirectToStripeDashboard} rpcState={getStripeUrlRpc.rpcState}>Go to Stripe
        dashboard</ActionButton>
    </>
  }

  return <>

    <div style={{flex: 0}}>
      <TabbedPageHeader pageTitle={'Billing'}
                        tabs={[
                          {label: 'Billing Profile', link: './', isSelected: true},
                          {label: 'Payments', link: './payments'},
                        ]}
      />
    </div>

    <div className={'ProviderToolAreaContent'}>

      <h2>Stripe integration</h2>

      {getContent()}

      {getStripeUrlRpc.rpcState.state == 'error' &&
          <p className="ErrorText">Something went wrong!</p>}
    </div>
  </>;
}